// 交易类型
export enum BillType {
  all = 8, //全部
}

// 端内/外
export enum ClientStatus {
  inApp = "0", // 端内
  webApp = "1", // 端外
}

// 弹窗类型
export enum PopStatus {
  typePicker = "1", // 类别筛选器
  timePicker = "2", // 时间筛选器
}
// 按钮类型
export enum ButtonName {
  typePicker = "1", // 类别筛选器
  timePicker = "2", // 时间筛选器
  balanceStatement = "3", // 单条余额流水
}
